import { render, staticRenderFns } from "./voc-cas.vue?vue&type=template&id=72c68688"
import script from "./voc-cas.vue?vue&type=script&lang=js"
export * from "./voc-cas.vue?vue&type=script&lang=js"
import style0 from "./voc-cas.vue?vue&type=style&index=0&id=72c68688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports